export interface IAction {
    type: string
    payload?: any
}

export type IParamID = {
    id: string
}

export interface IProductVariantParamID {
    id: string
    variantId: string
}
export const LocationTenantIdentifierID = 'LocationTenantIdentifierID'
export const CompanyTenantIdentifierID = 'CompanyTenantIdentifierID'
export const XCheftechServerKey = 'X-Cheftech-Server-Key'
export const ClientVersion = 'X-Client-Version'

export const RefreshToken = 'refreshToken'
export const Token = 'token'
